import { render, staticRenderFns } from "./CadastroPedagogicoView.vue?vue&type=template&id=56b07867&scoped=true"
import script from "./CadastroPedagogicoView.vue?vue&type=script&lang=js"
export * from "./CadastroPedagogicoView.vue?vue&type=script&lang=js"
import style0 from "./CadastroPedagogicoView.vue?vue&type=style&index=0&id=56b07867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b07867",
  null
  
)

export default component.exports